import CreativeVideoDetails from './CreativeVideoDetails';

export default CreativeVideoDetails;
